export default __webpack_public_path__ + "cb5f8ca1d4a576934453a78dd441e4a0.png";